// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__38gqR","label":"LabeledBox_label__xn5F3"};